export const MongodbAtlasIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M11.7345 2.22914C10.8947 1.23322 10.1715 0.221747 10.0315 0.0116709C10.016 -0.00389029 9.99266 -0.00389029 9.97711 0.0116709C9.82936 0.221747 9.10617 1.23322 8.26633 2.22914C1.06551 11.418 9.40167 17.6191 9.40167 17.6191L9.47165 17.6658C9.53386 18.6228 9.68939 20 9.68939 20H10.0004H10.3115C10.3115 20 10.467 18.6306 10.5292 17.6658L10.5992 17.6114C10.5992 17.6191 18.9354 11.418 11.7345 2.22914ZM10.0004 17.4791C10.0004 17.4791 9.62718 17.1601 9.52609 16.9967V16.9811L9.97711 6.9753C9.97711 6.94417 10.0238 6.94417 10.0238 6.9753L10.467 16.9811V16.9967C10.3659 17.1601 10.0004 17.4791 10.0004 17.4791Z"
        fill="#00684A"
      />
    </svg>
  );
};
